import React from "react";
import { HomePanel } from "../modules/home";
import { TodoPanel } from "../modules/todo";

const navItems = [
  { title: "Overview", meta: "Stream-ready SaaS shell", active: true },
  { title: "Workspace", meta: "Switch between task boards" },
  { title: "Board", meta: "Kanban workflow for each list" },
  { title: "Settings", meta: "Ready for future expansion" }
];

export default function Dashboard() {
  return (
    <div className="dashboard-shell">
      <aside className="dashboard-sidebar">
        <div className="dashboard-brand">
          <div className="dashboard-brand__eyebrow">Cammez Dev</div>
          <div className="dashboard-brand__title">Test Demo App</div>
          <div className="dashboard-brand__subtitle">Multi-workspace productivity dashboard for live AI builds</div>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <div
              key={item.title}
              className={`sidebar-nav__item${item.active ? " sidebar-nav__item--active" : ""}`}
            >
              <div className="sidebar-nav__title">{item.title}</div>
              <div className="sidebar-nav__meta">{item.meta}</div>
            </div>
          ))}
        </nav>
      </aside>

      <main className="dashboard-main">
        <div className="dashboard-topbar">
          <div>
            <h1 className="dashboard-title">Multi-List Workspace Dashboard</h1>
            <div className="dashboard-subtitle">
              Expanded from a single kanban board into a workspace-style app with multiple task lists,
              list management, and board switching for stronger live demo impact.
            </div>
          </div>
          <div className="dashboard-chip">Major Feature Upgrade · March 2026</div>
        </div>

        <div className="dashboard-grid">
          <HomePanel />
          <TodoPanel />
        </div>
      </main>
    </div>
  );
}
